import type {FC} from 'react';
import Link from 'next/link';

import type {ButtonProps} from '@/components/button';
import {Button} from '@/components/button';

export type CallToActionProps = {
	href: string;
	targetBlank?: boolean;
	text: string;
	buttonProps?: ButtonProps;
};

export const CallToAction: FC<CallToActionProps> = ({
	href,
	targetBlank,
	text,
	buttonProps,
}) => {
	return (
		<Button asChild {...buttonProps}>
			<Link href={href} {...(targetBlank && {target: '_blank'})}>
				{text}
			</Link>
		</Button>
	);
};
